module.exports = __webpack_public_path__ + "img/nexus.474dd603.png";